import { AppRegistry } from "react-native";
import App from "./App";
// import _App_modal from "./_App_modal";

AppRegistry.registerComponent("App", () => App);
AppRegistry.runApplication("App", {
  rootTag: document.getElementById("root")
});
// AppRegistry.registerComponent("_App_modal", () => _App_modal);
// AppRegistry.runApplication("_App_modal", {
//   rootTag: document.getElementById("root")
// });